import './CirclesBox.scss'
import React from 'react'

const CirclesBox = () => {
    return (
        <div className='circles-box'>
            <i className="fas fa-circle red"></i>
            <i className="fas fa-circle yellow"></i>
            <i className="fas fa-circle green"></i>
        </div>
    )
}

export default CirclesBox
